const validateNumericInput = (e) => {
  const regExp = /[0-9b]/i; /* Allows only numbers and Backspace */
  const { key } = e;

  if (!regExp.test(key)) e.preventDefault();
};

export default validateNumericInput;
